import { render, staticRenderFns } from "./Milliseconds.vue?vue&type=template&id=24e77b5a&"
import script from "./Milliseconds.vue?vue&type=script&lang=js&"
export * from "./Milliseconds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports